<template>
  <p :class="['paragraph', 'mb-3', 'text-sm', `text-${align}`]">
    <slot />
  </p>
</template>
<script>
export default {
  name: 'Paragraph',
  props: {
    align: {
      type: String,
      default: 'auto',
      validator: value => {
        return ['left', 'center', 'right', 'text-justify', 'auto'].includes(value)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/paragraph.vue